import { render, staticRenderFns } from "./newImport.vue?vue&type=template&id=c95c9556&scoped=true&"
import script from "./newImport.vue?vue&type=script&lang=js&"
export * from "./newImport.vue?vue&type=script&lang=js&"
import style0 from "./newImport.vue?vue&type=style&index=0&id=c95c9556&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c95c9556",
  null
  
)

export default component.exports